import _ from 'lodash';
import { browserHistory } from 'react-router'
import MONTHS from '../../data/months';
const DATES = require('../../data/dates');

const map = {
  'pro': 'clinton',
  'anti': 'trump',
  'neutral': 'other'
};

const helpers = {

  getMonths() {
    return this.months || _.chain(DATES)
      .groupBy(helpers.filterByDate)
      .map((value, key) => { return [key, value] })
      .value();
  },

  filterByDate(row) {
    const date = new Date(row.date);
    const month = MONTHS[date.getMonth()];
    const year = date.getFullYear();
    return `${month}-${year}`;
  },

  returnIndexOfMax(array) {
    const max = _.max(_.map(array, val => parseFloat((val))));

    let indexOfMax = array.indexOf(max);
    if (indexOfMax === -1) {
      indexOfMax = array.indexOf('' + max);
    }

    return indexOfMax;
  },

  average(data, key, query = {}) {
    return _.chain(data)
      .filter(query)
      .map(key)
      .reduce((memo, val, iter, array) => {
        return memo + val / array.length;
      }, 0)
      .value();
  },

  redirectToLastWave(dataset, wave, month) {
    if (!wave && !month) {
      const lastMonth = _.last(this.getMonths());
      const month = lastMonth[0];
      const wave = _.last(lastMonth[1]).wave;

      browserHistory.push(`${window.location.pathname}/${month}/${wave}`);
    }
  },

  transformKeys(row) {
    return _.transform(row, (result, value, key) => {
      result[map[key] || key] = value;
    });
  },

  transformValuesRecursively(data) {
    return _.map(data, (row) => {
      return _.transform(row, (result, value, key) => {
        result[key] = map[value] || value;
      });
    });
  },

  transformKeysRecursively(data) {
    return _.map(data, (row) => {
      return this._transformKeys(row);
    });
  }
};

export default helpers;



/** WEBPACK FOOTER **
 ** ./src/components/data_visualisation/helpers.js
 **/